export const mallKeys = {
  all: () => ['malls'] as const,
  list: () => [...mallKeys.all(), 'list'] as const,
};
